import { C, cExp } from './complex';

/**
 * Standard single-qubit gate matrices, each as [[a, b], [c, d]] of complex
 * amplitudes, applying to a state as usual: [a b; c d] * [amp0; amp1].
 */

const SQRT1_2 = 1 / Math.sqrt(2);

export const I = [[C(1), C(0)], [C(0), C(1)]];
export const X = [[C(0), C(1)], [C(1), C(0)]];
export const Y = [[C(0), C(0, -1)], [C(0, 1), C(0)]];
export const Z = [[C(1), C(0)], [C(0), C(-1)]];
export const H = [[C(SQRT1_2), C(SQRT1_2)], [C(SQRT1_2), C(-SQRT1_2)]];

// Phase gates: S = Z^(1/2), T = Z^(1/4).
export const S = [[C(1), C(0)], [C(0), cExp(Math.PI / 2)]];
export const T = [[C(1), C(0)], [C(0), cExp(Math.PI / 4)]];
export const Sdag = [[C(1), C(0)], [C(0), cExp(-Math.PI / 2)]];
export const Tdag = [[C(1), C(0)], [C(0), cExp(-Math.PI / 4)]];

// Parametrised rotations about X, Y, Z (angle in radians).
export const Rx = (theta) => {
  const c = Math.cos(theta / 2);
  const s = Math.sin(theta / 2);
  return [[C(c), C(0, -s)], [C(0, -s), C(c)]];
};

export const Ry = (theta) => {
  const c = Math.cos(theta / 2);
  const s = Math.sin(theta / 2);
  return [[C(c), C(-s)], [C(s), C(c)]];
};

export const Rz = (theta) => [
  [cExp(-theta / 2), C(0)],
  [C(0), cExp(theta / 2)],
];

export const GATE_INFO = {
  I: { matrix: I, symbol: 'I', name: 'Identity', description: 'Leaves the qubit unchanged.' },
  X: { matrix: X, symbol: 'X', name: 'Pauli-X (NOT)', description: 'Flips |0⟩ ↔ |1⟩ — a bit-flip / 180° rotation about the X axis.' },
  Y: { matrix: Y, symbol: 'Y', name: 'Pauli-Y', description: '180° rotation about the Y axis; flips the bit and the phase.' },
  Z: { matrix: Z, symbol: 'Z', name: 'Pauli-Z', description: 'Leaves |0⟩ unchanged, flips the sign of |1⟩ — a phase-flip.' },
  H: { matrix: H, symbol: 'H', name: 'Hadamard', description: 'Creates equal superposition: |0⟩→|+⟩, |1⟩→|−⟩.' },
  S: { matrix: S, symbol: 'S', name: 'S (√Z)', description: 'Quarter-turn phase gate: rotates 90° about the Z axis.' },
  T: { matrix: T, symbol: 'T', name: 'T (⁴√Z)', description: 'Eighth-turn phase gate: rotates 45° about the Z axis.' },
};
